<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css" />

<div fxLayout="row" fxLayoutAlign="start center">
  <div class="breadcrumb">
    <p>
      <a [routerLink]="'/dashboard'" class="breadcrumb-link">Home</a> /
      <span>Photo Upload</span>
    </p>
  </div>
</div>

<div class="container" fxLayout="column" fxLayoutAlign="center" fxLayoutGap="10">
  <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex.gt-xs="90" fxFlex.xs="100">
    <mat-card-header>Photo Upload</mat-card-header>
    <button mat-icon-button class="close-icon" (click)="navigate()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <p class="content">Add your image here to upload</p>
  <div class="upload-container" (drop)="onFileDrop($event)" (dragover)="onFileOver($event)">
    <div class="upload-div" fxLayout="column" fxLayoutAlign="center center" fxFlex="100">
      <ng-container *ngIf="!showProgress">
        <span class="upload-icon"><i class="fas fa-cloud-upload-alt"></i></span>
        <button mat-raised-button class="upload-button" (click)="photoUpload($event)">Upload</button>
        <span>Drag your file or <a (click)="triggerFileInput($event)">Browse</a></span>
        <input type="file" #fileInput (change)="onFileSelected($event)" hidden accept=".jpeg, .jpg, .png">
      </ng-container>
      
      <ng-container *ngIf="showProgress">
        <div class="progress-container" fxLayout="column" fxLayoutAlign="center center">
          <mat-progress-spinner [color]="'primary'" [mode]="'determinate'" [value]="progress" diameter="50">
          </mat-progress-spinner>
          <p class="progress-info">{{progress}}%</p>
          <span>Uploading...</span>
          <button mat-button class="cancel-button" (click)="abortUpload()">Cancel</button>
        </div>
      </ng-container>
      <span class="file-types">Only support .jpg, .jpeg and .png files</span>
    </div>
  </div>

  <div class="OR-wrapper" fxFlex="100">
    <span class="ORcontent">OR</span>
  </div>

  <div fxLayout="column" fxLayoutAlign="center" fxLayoutGap="10px" fxFlex="100">
    <mat-card-header>Upload from URL</mat-card-header>
    <div class="url-upload-div" fxLayout="row" fxLayoutAlign="start stretch" fxFlex="100">
      <input type="text" class="url-input" #urlInput fxFlex="90" placeholder="Paste image URL here">
      <button mat-raised-button class="url-upload-button" fxFlex="10" (click)="uploadFromUrl(urlInput.value)">Upload</button>
    </div>
    <div *ngIf="urlError" class="error-message">{{ urlError }}</div>

    <div *ngIf="showUrlProgress" class="progress-container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" fxFlex="100">
      <mat-progress-bar fxFlex="100" mode="determinate" [value]="urlProgress"></mat-progress-bar>
      <p class="progress-detail">{{urlProgress}}%</p>
      <div fxFlex="auto"></div>
      <button mat-icon-button class="abort-upload" (click)="abortUpload()">
        <i class="fas fa-times abort"></i>
      </button>
    </div>
  </div>
</div>
